import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Button } from 'react-bootstrap';
import styles from '../styles/about/CookieConsent.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench} from '@fortawesome/free-solid-svg-icons';

const CookieNotice = (props) => {

    const {showOptions, saveCookie} = props;

    const saveAllCookies = () =>{
        let opt = {
            consented: 1,
            categories: {
                analytics: 1,
                personal: 1,
            },
            consentDate: new Date(),
        }
        saveCookie(opt);
    }

    const rejectAllCookies = () =>{
        let opt = {
            consented: 1,
            categories: {
                analytics: 0,
                personal: 0,
            },
            consentDate: new Date(),
        }
        saveCookie(opt);
    }

    return (
        <dialog className={styles.root} >
            <div className={styles.dialogOverlay} ></div>
            <div className={styles.container}>
                <div className={styles.consentRoot} >
                    {/* <div className={styles.logo} >
                        <Image src="/images/icons/conso.png" width={70} height={21} alt="Conso" />  
                    </div> */}
                    
                    <p className="heading3 text-center font-weight-bold">Ești de acord cu cookie-urile opționale?</p>
                    <p className={styles.infoText}>
                        Acestea ne ajută sa îți oferim o experiență mai bună, să înțelegem cum utilizezi portalul și să îti oferim o navigare facilă. Află mai multe în <Link
                        href={`${process.env.NEXT_PUBLIC_WEB}/termeni/cookies`}
                        title="Politica Cookies"
                        target="_blank">Politica privind cookies</Link>.
                    </p>
                   
                    <div className={`d-flex justify-content-around flex-column flex-lg-row ${styles.optButtons}`}>
                        <Button variant="secondary" onClick={saveAllCookies}>Accept</Button>
                        <Button variant="secondary" onClick={rejectAllCookies}>Refuz</Button>
                        <Button variant="outline-secondary" onClick={showOptions}>
                            <FontAwesomeIcon icon={faWrench} height="16" width="16" className="me-2"/>
                            Opțiuni
                        </Button>
                    </div>
                </div>  
            </div>
        </dialog>
    );
}

export default CookieNotice;